<template>
  <div>
    <CModal color="dark" centered :show.sync="show_profile" style="z-index: 30" size="lg">
      <template #header>
        <strong style="text-transform: uppercase">Profilo Utente</strong>
        <CButton class="close" @click="show_profile = false">
          <!-- <button type="button" class="close" aria-label="Close"> -->
          <span aria-hidden="true">&times;</span>
        </CButton>
      </template>
      <template>
        <div class="d-flex align-items-center">
          <CContainer fluid>
            <CRow class="justify-content-center">
              <CCol>
                <CCard>
                  <CCardBody align="center">
                    <h1>{{ user.Nominativo }}</h1>
                    <div>
                      <p><b>E-mail:</b> {{ user.Email }}</p>
                    
                    </div>
                    

                   
                  </CCardBody>
                </CCard>
              </CCol>
            </CRow>
          </CContainer>
        </div>
      </template>

      <template #footer>
        <CButton @click="show_profile = false" color="dark" size="sm" variant="outline">
          Chiudi
        </CButton>
      </template>
    </CModal>

    <CModal id="logout_modale" color="dark" centered :show.sync="logout_modale" style="z-index: 30" size="sm"
      :closeOnBackdrop="false">
      <template #header>
        <strong style="text-transform: uppercase">Logout</strong>
      </template>
      <template>
        <div class="d-flex align-items-center">
          <CContainer fluid>
            <CRow class="justify-content-center">
              <img src="img/logout.gif" />
              <span class="text-center"><strong>Chiusura in corso...<br />Attendi 5 secondi e sarai
                  reindirizzato alla pagina di login.</strong>
              </span>
            </CRow>
          </CContainer>
        </div>
      </template>

      <template #footer>
        <span></span>
      </template>
    </CModal>

    <CDropdown inNav class="c-header-nav-items" placement="bottom-end" add-menu-classes="pt-0">
      <template #toggler>
        <CHeaderNavLink>
          <div id="user_option" class="c-avatar"
            v-c-tooltip="{ content: 'OPZIONI', placement: 'bottom-end' }">
            <i class="far fa-user"></i>
          </div>
        </CHeaderNavLink>
      </template>
      <CDropdownHeader tag="div" class="text-center" color="light" v-if="admin">
        <strong>Utility</strong>
      </CDropdownHeader>
      <CDropdownItem to="/GeneratoreFirme" v-if="firma">
        <i class="fas fa-file-signature"></i>
        <span class="pl-1">Genera Firma</span>
      </CDropdownItem>
      
      <CDropdownHeader tag="div" class="text-center" color="light">
        <strong>Account</strong>
      </CDropdownHeader>
      
      <CDropdownItem @click="Get_user()">
        <i class="far fa-user"></i> <span class="pl-1">Profilo</span>
      </CDropdownItem>
      <CDropdownItem @click="Logout()">
        <CIcon :content="$options.logout_ico" /> Logout
      </CDropdownItem>
    </CDropdown>
  </div>
</template>

<script>

import { cilAccountLogout } from "@coreui/icons";
export default {
  name: "MenuUser",
  logout_ico: cilAccountLogout,
  data() {
    return {
      admin: false,
      firma: false,
      logout_modale: false,
      show_profile: false,
      url_logout: "",
      user: JSON.parse(localStorage.getItem("chisono_data")),
      // userCRMInfo: [],
    };
  },
  // computed: {
  //   accessoCRM() {
  //     // console.log(this.userCRMInfo.idbroker);
  //     return this.userCRMInfo.idbroker ? true : false;
  //   },
  // },
  // mounted() {
  //   this.getUserCRMInfo();
  // },
  methods: {
    // attiva/disattiva il loader, emettendo un evento
    // che viene ascoltato da TheHeader che propaga a TheContainer
    // se specificato un timeout, il loader torna allo stato precedente
    setLoading(is_loading, timeout_ms = null) {
      this.$emit("set-loading", is_loading, timeout_ms);
    },

    // async getUserCRMInfo() {
    //   let param = {
    //     idUtente: this.user["idUtente"],
    //   };
    //   try {
    //     await axios
    //       .post(
    //         this.$custom_json.base_url +
    //         this.$custom_json.api_url +
    //         this.$custom_json.crm.accessoCRM,
    //         param
    //       )
    //       .then((response) => {
    //         this.userCRMInfo = response.data;
    //         localStorage.setItem(
    //           "userCRMInfo",
    //           JSON.stringify(this.userCRMInfo)
    //         );
    //       });
    //   } catch (error) {
    //     console.error(error);
    //   }
    // },
    
    Get_user() {
      this.show_profile = true;
    },

   Logout() {
  this.logout_modale = true; // se vuoi mostrare la modale di “uscita”
  this.$store.dispatch('logout');

  // reindirizza alla Login (assoluta, come abbiamo sistemato)
  this.$router.replace({ name: 'Login' });

  // Se vuoi essere ultra-sicuro di ripulire qualsiasi stato in RAM di componenti:
  // this.$router.replace({ name: 'Login' }).then(() => window.location.reload());
}
  },
};
</script>
